(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/react/components/login-check/check-terms/review-terms.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/react/components/login-check/check-terms/review-terms.js');

'use strict';

const {
  useEffect
} = React;
const {
  ReactIcon: Icon,
  ReactButton: Button
} = svs.ui;
const {
  returnUrl
} = svs.utils.url.queryString;
const {
  isPnp
} = svs.legal_info.data;
const {
  isPoker
} = svs.legal_info.data.loginCheckOptions.model;
const ReviewTerms = () => {
  useEffect(() => {
    svs.core.jupiter.call({
      method: 'POST',
      path: '/player/1/terms',
      data: {}
    }, () => {}, err => {
      svs.accountservices.check_terms.logger.error('Unable to POST review of terms to /player/1/terms', err);
    });
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("section", {
    className: "f-content"
  }, React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement("div", {
    className: "margin-top-1 margin-bottom-2 align-center"
  }, React.createElement(Icon, {
    color: isPnp ? 'fc-momang' : 'fc-sport-75',
    icon: "gdpr-terms-changes",
    size: "1000"
  })), React.createElement("h1", {
    className: "align-center f-prominent"
  }, "Nya villkor hos Svenska Spel Sport & Casino AB"))), React.createElement("div", {
    className: "grid-row f-content padding-xs-h-1"
  }, React.createElement("div", {
    className: "col-xs-12 col-sm-6 col-sm-offset-3"
  }, React.createElement("p", {
    className: "margin-top-1"
  }, "Vi har uppdaterat v\xE5ra villkor f\xF6r dig som \xE4r kund hos Svenska Spel Sport & Casino AB."), React.createElement("p", null, "L\xE4s g\xE4rna mer om de viktigaste f\xF6r\xE4ndringarna p\xE5 v\xE5r", ' ', React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: svs.core.urlMapping.get('updatedTermsInfoPage'),
    rel: "noreferrer",
    target: "_blank"
  }, "informationssida"), "."), React.createElement("p", null, "De nya kundvillkoren i sin helhet hittar du", ' ', React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: svs.core.urlMapping.get('termsIntegrityHome'),
    rel: "noreferrer",
    target: "_blank"
  }, "h\xE4r"), "."), React.createElement("div", {
    className: "grid-row gutter-xs-1 margin-top-2"
  }, React.createElement("div", {
    className: "col-xs-6 col-xs-offset-3"
  }, React.createElement(Button, {
    block: true,
    focus: true,
    href: returnUrl
  }, "Forts\xE4tt"))), React.createElement("div", {
    className: "margin-top-2"
  }, "Har du fr\xE5gor? Kontakta", ' ', isPoker ? React.createElement("span", null, "Kundservice Svenska Spel Sport & Casino: 0770 - 11 11 11") : React.createElement("a", {
    className: isPnp ? 'fc-momang' : 'fc-sport-75',
    href: svs.core.urlMapping.get('customerServiceContact'),
    rel: "noreferrer",
    target: "_blank"
  }, "Kundservice Svenska Spel Sport & Casino")))));
};
svs.legal_info.components.login_check.check_terms.ReviewTerms = ReviewTerms;

 })(window);